var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// eslint-disable-next-line @typescript-eslint/triple-slash-reference
///<reference path='../button/button-model.d.ts'/>
import { Button } from '../button/button';
import { EventHandler, Property } from '@syncfusion/ej2-base';
export class SmartPasteButton extends Button {
    /**
     * Constructor for creating the widget
     *
     * @private
     * @param {SmartPasteButtonModel} options - Specifies Smart paste button model
     * @param {string | HTMLButtonElement} element - Specifies target element
     */
    constructor(options, element) {
        super(options, element);
    }
    wireEvents() {
        EventHandler.add(this.element, 'click', this.smartPasteBtnClickHandler, this);
    }
    unWireEvents() {
        EventHandler.remove(this.element, 'click', this.smartPasteBtnClickHandler);
    }
    smartPasteBtnClickHandler(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = args.target;
            const formElement = target.closest('form');
            if (!formElement) {
                return;
            }
            const formFields = this.getFormFields(formElement);
            if (formFields.length === 0) {
                return;
            }
            const clipboardContent = yield this.getClipboardContent().then((text) => {
                return text;
            });
            if (clipboardContent !== 'Clipboard API not supported' && clipboardContent !== 'Clipboard access failed') {
                try {
                    this.disabled = true;
                    const fieldsData = formFields.map((field) => {
                        return {
                            fieldName: field.fieldName,
                            description: field.description,
                            allowedValues: field.allowedValues,
                            type: field.type
                        };
                    });
                    const systemRole = `
Current date: ${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}

Each response line matches the following format:
FIELD identifier^^^value

Give a response with the following lines only, with values inferred from USER_DATA:
${this.formatFields(fieldsData)}
END_RESPONSE

Do not explain how the values were determined.
For fields without any corresponding information in USER_DATA, use value NO_DATA.`;
                    const userRole = `
USER_DATA: ${clipboardContent}
                    `;
                    const settings = {
                        messages: [
                            { role: 'system', content: systemRole },
                            { role: 'user', content: userRole }
                        ],
                        temperature: 0.0,
                        topP: 1.0,
                        maxTokens: 2000,
                        frequencyPenalty: 0.1,
                        presencePenalty: 0.0,
                        stop: ['END_RESPONSE']
                    };
                    if (typeof this.aiAssistHandler === 'function') {
                        const response = yield this.aiAssistHandler(settings);
                        if (typeof response === 'string' && response !== '') {
                            this.setFormFields(formElement, formFields, response);
                        }
                    }
                }
                finally {
                    this.disabled = false;
                }
            }
        });
    }
    formatFields(fields) {
        const result = [];
        fields.forEach((field) => {
            const fieldOutput = [];
            fieldOutput.push(`\nFIELD ${field.fieldName}^^^`);
            if (field.description) {
                fieldOutput.push(`The ${field.description}`);
            }
            if (field.allowedValues && field.allowedValues.length > 0) {
                fieldOutput.push(' (multiple choice, with allowed values: ');
                fieldOutput.push(field.allowedValues.map((val) => `${val}`).join(','));
                fieldOutput.push(')');
            }
            else {
                fieldOutput.push(` of type ${field.type}`);
            }
            result.push(fieldOutput.join(''));
        });
        return result.join('');
    }
    setFormFields(form, formFields, response) {
        const responseData = {};
        const fieldPrefix = 'FIELD ';
        let currentField = null;
        response.split('\n').forEach((line) => {
            if (line.startsWith(fieldPrefix)) {
                const parts = line.substring(fieldPrefix.length).split('^^^');
                if (parts.length === 2) {
                    responseData[`${parts[0]}`] = parts[1];
                    currentField = parts[0];
                }
            }
            else if (currentField) {
                responseData[`${currentField}`] += '\n' + line;
            }
        });
        formFields.forEach((field) => {
            let value = responseData[field.fieldName];
            if (value !== undefined) {
                value = value.trim();
                if (value === 'NO_DATA') {
                    return;
                }
                if (field.element instanceof HTMLInputElement && field.element.type === 'radio') {
                    const radioButton = this.findRadioButton(form, field.element.name, value);
                    if (radioButton) {
                        this.updateElementValue(radioButton, 'true');
                    }
                }
                else {
                    this.updateElementValue(field.element, value);
                }
            }
        });
    }
    findRadioButton(form, name, value) {
        const radioButtons = Array.from(form.querySelectorAll('input[type=radio]'))
            .filter((radio) => radio instanceof HTMLInputElement && radio.name === name)
            .map((radio) => ({ elem: radio, text: this.getElementDescription(form, radio) }));
        const exactMatch = radioButtons.find((radio) => radio.text === value);
        if (exactMatch) {
            return exactMatch.elem;
        }
        const partialMatch = radioButtons.filter((radio) => radio.text &&
            radio.text.includes(value));
        if (partialMatch.length === 1) {
            return partialMatch[0].elem;
        }
        return null;
    }
    triggerBeforeChange(element) {
        element.dispatchEvent(new CustomEvent('beforeinput', {
            bubbles: true,
            detail: {
                fromSmartComponents: true
            }
        }));
    }
    triggerAfterChange(element) {
        element.dispatchEvent(new CustomEvent('input', {
            bubbles: true,
            detail: {
                fromSmartComponents: true
            }
        }));
        element.dispatchEvent(new CustomEvent('change', {
            bubbles: true,
            detail: {
                fromSmartComponents: true
            }
        }));
    }
    updateElementValue(element, value) {
        const isEjsControl = element.classList.contains('e-control');
        if (element instanceof HTMLInputElement && (element.type === 'radio' || element.type === 'checkbox')) {
            const responseValue = value == null ? undefined : value.toString().toLowerCase();
            const isResponseValue = responseValue === 'true' || responseValue === 'yes' || responseValue === 'on';
            if (element.checked !== isResponseValue) {
                this.triggerBeforeChange(element);
                if (isEjsControl) {
                    element['ej2_instances'][0].checked = isResponseValue;
                }
                else {
                    element.checked = isResponseValue;
                }
                this.triggerAfterChange(element);
            }
        }
        else if (element instanceof HTMLSelectElement) {
            const optionText = value.toString();
            let index = null;
            const options = Array.from(element.querySelectorAll('option'));
            const exactMatch = options.filter((option) => option.textContent === optionText);
            if (exactMatch.length > 0) {
                index = options.indexOf(exactMatch[0]);
            }
            else {
                const partialMatch = options.filter((option) => option.textContent &&
                    option.textContent.indexOf(optionText) >= 0);
                if (partialMatch.length === 1) {
                    index = options.indexOf(partialMatch[0]);
                }
            }
            if (index !== null && element.selectedIndex !== index) {
                this.triggerBeforeChange(element);
                if (isEjsControl) {
                    element['ej2_instances'][0].index = index;
                }
                else {
                    element.selectedIndex = index;
                }
                this.triggerAfterChange(element);
            }
        }
        else {
            this.triggerBeforeChange(element);
            if (element.classList.contains('e-rating') || element.classList.contains('e-colorpicker')) {
                element['ej2_instances'][0].value = value;
            }
            else {
                element.value = value;
            }
            this.triggerAfterChange(element);
        }
        element.focus();
    }
    getFormFields(form) {
        const fields = [];
        let uniqueCount = 0;
        form.querySelectorAll('input, select, textarea').forEach((element) => {
            if (!(element instanceof HTMLInputElement || element instanceof HTMLSelectElement || element instanceof HTMLTextAreaElement)) {
                return;
            }
            if (element.type === 'hidden' || this.isFieldIgnore(element)) {
                return;
            }
            const isRadioButton = element.type === 'radio';
            const identifier = isRadioButton ? element.name : element.id || element.name || `unidentified_${++uniqueCount}`;
            if (isRadioButton && fields.find((field) => field.fieldName === identifier)) {
                return;
            }
            let FieldDescription = null;
            if (!isRadioButton) {
                FieldDescription = this.getElementDescription(form, element);
                if (!FieldDescription) {
                    return;
                }
            }
            const fieldInfo = {
                fieldName: element.name,
                description: FieldDescription,
                element: element,
                type: element.type === 'checkbox' ? 'boolean' : element.type === 'number' ? 'number' : 'string'
            };
            if (element instanceof HTMLSelectElement) {
                const options = Array.from(element.querySelectorAll('option')).filter((option) => option.value);
                fieldInfo.allowedValues = options.map((option) => option.textContent);
                fieldInfo.type = 'fixed-choices';
            }
            else if (isRadioButton) {
                fieldInfo.allowedValues = [];
                fieldInfo.type = 'fixed-choices';
                Array.from(form.querySelectorAll('input[type=radio]')).forEach((radio) => {
                    if (radio.name === identifier) {
                        const radioDescription = this.getElementDescription(form, radio);
                        if (radioDescription) {
                            fieldInfo.allowedValues.push(radioDescription);
                        }
                    }
                });
            }
            fields.push(fieldInfo);
        });
        return fields;
    }
    isFieldIgnore(element) {
        return element.hasAttribute('data-smartpaste-ignore') ||
            (element.hasAttribute('aria-disabled') && element.getAttribute('aria-disabled') === 'true') ||
            (element.hasAttribute('disabled')) || (element.hasAttribute('readonly')) ||
            (element.hasAttribute('aria-readonly') && element.getAttribute('aria-readonly') === 'true') ||
            (element.hasAttribute('aria-hidden') && element.getAttribute('aria-hidden') === 'true');
    }
    getElementDescription(form, element) {
        if (element.hasAttribute('data-smartpaste-description')) {
            return element.getAttribute('data-smartpaste-description');
        }
        if ((element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement) && element.placeholder) {
            return element.placeholder;
        }
        const label = form.querySelector(`label[for="${element.id}"]`);
        if (label) {
            return label.textContent.trim();
        }
        return element.name || element.id;
    }
    getClipboardContent() {
        return __awaiter(this, void 0, void 0, function* () {
            const navigatorObj = navigator;
            const customClipboard = document.getElementById('custom-clipboard');
            if (customClipboard && customClipboard.value) {
                return customClipboard.value;
            }
            else if (typeof window !== 'undefined' && navigatorObj.clipboard && navigatorObj.clipboard.readText) {
                try {
                    return yield navigatorObj.clipboard.readText();
                }
                catch (error) {
                    return 'Clipboard access failed';
                }
            }
            else {
                return 'Clipboard API not supported';
            }
        });
    }
}
__decorate([
    Property()
], SmartPasteButton.prototype, "aiAssistHandler", void 0);
